import BaseLayout from '@/components/BaseLayout.vue';
import api from '@/services/api';
import router from '@/router';
import { mapActions } from 'vuex';
import Modal from '@/components/Partials/Modal.vue';

export default {
    name: 'newPromotionBaseSettings',
    data() {
        return {
            promotionType: 1, // Type za obicnu je 1
            imageId: null,
            promotionWithSamples: 1,
            showLoader: false,
            showModal: false,
        }
    },

    components: {
        BaseLayout,
        Modal,
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),
        /**
         * Set image in data object when user upload image
         * @param event
         */
        uploadImage(event) {
            this.showLoader = true;
            let formData = new FormData();
            formData.append('file', event.target.files[0])
            api.post('/api/assets', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    this.imageId = response.data.body.entry.id;
                    this.showLoader = false;
                })
                .catch((error) => {
                    this.showLoader = false;
                });
        },

        /**
         * Send to server new created promotion
         */
        submitCreatePromotion: function () {
            const params = new FormData();
            params.append('type', this.promotionType);
            params.append('promotion_with_samples', Number(this.promotionWithSamples) === 1 ? 1 : 0);
            params.append('promotion_with_gifts', Number(this.promotionWithSamples) === 1 ? 0 : 1);
            params.append('promotion_stand', this.imageId);

            api.post(`/api/promotions_start/${this.$route.params.id}`, params)
                .then(() => {
                    this.storePromotion();
                    router.replace('/promotion')
                })
                .catch((error) => {
                });
        },

        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    },
}